'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { IconX } from '../Icons/Status/X.js';
import { Button } from '../Button/Button.js';

const getTransitionSpeed = cssCustomProperty => {
  const speed = getComputedStyle(document.documentElement).getPropertyValue(cssCustomProperty).trim();
  if (speed.endsWith('ms')) {
    return parseFloat(speed);
  } else if (speed.endsWith('s')) {
    return parseFloat(speed) * 1000;
  } else {
    return 0;
  }
};
const Drawer = _ref => {
  let {
    isOpen: propIsOpen,
    onClose,
    showTrigger,
    position = 'left',
    children,
    className,
    ...otherProps
  } = _ref;
  const [isOpen, setIsOpen] = useState(propIsOpen);
  const drawerRef = useRef(null);
  useEffect(() => {
    if (propIsOpen) {
      if (drawerRef.current && !drawerRef.current.open) {
        drawerRef.current.showModal();
        setIsOpen(true);
      }
    } else {
      setIsOpen(false);
      const timeout = setTimeout(() => {
        if (drawerRef.current && drawerRef.current.open) {
          drawerRef.current.close();
        }
      }, getTransitionSpeed('--drawer-speed') || 300);
      return () => clearTimeout(timeout);
    }
  }, [propIsOpen]);
  useEffect(() => {
    const dialog = drawerRef.current;
    if (!dialog) return;
    const handleClickOutside = event => {
      if (propIsOpen && onClose && event.target === dialog) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, propIsOpen]);
  return /*#__PURE__*/React__default.createElement("dialog", _extends({}, otherProps, {
    className: classnames(`b-drawer b-drawer--${position}`, className, {
      'b-drawer--open': isOpen,
      'b-drawer--closed': !isOpen
    }),
    ref: drawerRef,
    "data-testid": "drawer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "b-drawer__content"
  }, showTrigger && /*#__PURE__*/React__default.createElement("div", {
    className: "b-drawer__close-container"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "b-drawer__close",
    size: "small",
    variant: "plain",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(IconX, null))), children));
};
Drawer.displayName = 'Drawer';

export { Drawer };
